import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customCurrency'
})
export class CustomCurrencyPipe implements PipeTransform {
  transform(value: number): string {
    if (value == null) return '';
    
    const absValue = Math.abs(value);
    const formattedNumber = absValue.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    
    return value < 0 ? `(${formattedNumber})` : formattedNumber;
  }
}
